export default "https://fiverr-res.cloudinary.com/npm-assets/@fiverr/search_perseus/astrology_psychics.1697fa0.svg";